import { createRouter, createWebHistory } from 'vue-router';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import Photos from './views/Photos.vue';
import Dress from './views/Dress.vue';
import MakeUp from './views/MakeUp.vue';
import Emcee from './views/Emcee.vue';
import Plan from './views/Plan.vue';
import Car from './views/Car.vue';
import Restaurant from './views/Restaurant.vue';



const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,

  },
  {
    path: '/photos',
    name: 'Photos',
    component: Photos,
    meta: { requiresAuth: true }

  },
  {
    path: '/dress',
    name: 'Dress',
    component: Dress,
    meta: { requiresAuth: true }

  },
  {
    path: '/makeUp',
    name: 'MakeUp',
    component: MakeUp,
    meta: { requiresAuth: true }

  },
  {
    path: '/emcee',
    name: 'Emcee',
    component: Emcee,
    meta: { requiresAuth: true }

  },
  {
    path: '/plan',
    name: 'Plan',
    component: Plan,
    meta: { requiresAuth: true }

  },
  {
    path: '/car',
    name: 'Car',
    component: Car,
    meta: { requiresAuth: true }

  },
  {
    path: '/restaurant',
    name: 'Restaurant',
    component: Restaurant,
    meta: { requiresAuth: true }

  },
];

const router = createRouter({
  history: createWebHistory('/toy/'),
  routes,
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('token'); 

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (isAuthenticated) {
      next(); 
    } else {
      next('/login'); 
    }
  } else {
    next(); 
  }
});

export default router;
